module.exports = __webpack_public_path__ + "media/logo.svg";